import { configService } from '@/common/utils/clientConfig'

export enum CoreExecutorType {
  EIS = 'EIS',
  WF = 'WF',
  REPORTS = 'REPORTS',
  DYNAMICVIEW = 'DYNAMICVIEW',
  ALL = 'ALL',
  UNKNOWN = 'UNKNOWN'
}

function validateCoreType(type: string | undefined | null): CoreExecutorType {
  if (!type) {
    return CoreExecutorType.UNKNOWN
  }

  const upperType = type.toUpperCase()

  if (Object.values(CoreExecutorType).includes(upperType as CoreExecutorType)) {
    return upperType as CoreExecutorType
  }

  console.warn(`Invalid core type: "${type}", using UNKNOWN`)
  return CoreExecutorType.UNKNOWN
}

export const CORE_TYPE = validateCoreType(configService.get('CORE_TYPE'))

export const getCoreType = (): CoreExecutorType => {
  return validateCoreType(configService.get('CORE_TYPE'))
}
